export default "__VITE_ASSET__Dn3VET_m__"